export default "__VITE_ASSET__VEMKXPPL__"